import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    isProduction: __PRODUCTION__,
    zgEnv: 'local',
    zgApi: '',
    zgApiPublic: '',
    nodeEnv: 'development',
    metroidConfigUrlCapture: '',
    metroidConfigUrlCharge: '',
    metroidProductId: '',
});

const env = (state = initState(), action) => {
    const { type, payload } = action;
    switch (type) {
        case DispatchConstants.SET_ENV:
            return { ...state, ...payload };
        default:
    }
    return state;
};

export default env;
